import React, { useContext, useState } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Checkbox,
  ListItemSecondaryAction,
  Divider,
} from '@material-ui/core'

import { FirestoreContext } from '../../providers/firestore-provider'
import { useDispatch } from 'react-redux'
import { openSnackbar } from '../../ducks/snackbar/actions'
import { addDoseToSeveralCircles, ICircle, IDose } from 'daily-dose-common'
import buildInfo from '../../../package.json'

export interface IAddDoseToCirclesOptionModalProps {
  open: boolean
  dose: IDose
  onClose: (success: boolean) => void
}

export const AddDoseToCirclesOptionModal = ({
  onClose,
  dose,
  open,
}: IAddDoseToCirclesOptionModalProps) => {
  const { currentUser, myCircles } = useContext(FirestoreContext)
  const dispatch = useDispatch()

  const circlesInitialState = myCircles?.map((circle) => ({
    ...circle,
  }))

  const [selectedCircles, setSelectedCircles] = useState(() => circlesInitialState)

  const onToggleCheckbox = (circle: ICircle) => {
    const shouldRemove = selectedCircles.some((c) => c.id === circle.id)

    if (shouldRemove) {
      setSelectedCircles((selectedCircles) =>
        selectedCircles.filter((c) => c.id !== circle.id)
      )
    } else {
      setSelectedCircles((selectedCircles) => selectedCircles.concat(circle))
    }
  }

  const isCircleChecked = (circle: ICircle) =>
    selectedCircles.some((c) => c.id === circle.id)

  const onAddDoseToCircles = async () => {
    if (!!selectedCircles.length && currentUser && dose.id) {
      const { name, description, id } = dose
      try {
        await addDoseToSeveralCircles(
          selectedCircles,
          currentUser,
          name,
          description,
          buildInfo.version,
          id
        )

        dispatch(openSnackbar(`Awesome! You just added a suggested dose`, 'success'))
        onClose(true)
      } catch (error) {
        console.warn('Error: Could not add suggested dose ', error)
        dispatch(
          openSnackbar(`Opps. We could not the dose. Please try again`, 'error')
        )
        onClose(false)
      }
    }
    return onClose(false)
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
    >
      <DialogTitle id="simple-dialog-title">Choose group</DialogTitle>
      <List>
        {myCircles?.map((circle) => (
          <ListItem
            key={circle.id!}
            role={undefined}
            dense
            button
            onClick={() => onToggleCheckbox(circle)}
          >
            <ListItemAvatar>
              <Avatar alt={circle.name} src={circle.photoURL} />
            </ListItemAvatar>
            <ListItemText id={circle.id!} primary={circle.name} />
            <ListItemSecondaryAction>
              <Checkbox
                color="primary"
                edge="end"
                checked={!!isCircleChecked(circle)}
                onChange={() => onToggleCheckbox(circle)}
                inputProps={{ 'aria-labelledby': circle.id! }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Divider />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          padding: '5px',
          justifyContent: 'space-between',
        }}
      >
        <Button color="secondary" onClick={() => onClose(false)} fullWidth>
          Cancel
        </Button>
        <Button color="primary" onClick={onAddDoseToCircles} fullWidth>
          Add
        </Button>
      </div>
    </Dialog>
  )
}
